import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import smoothscroll from 'smoothscroll-polyfill';

if (process.browser) {
  smoothscroll.polyfill();
}